import React, { Component } from "react";
import "./NewWarehouse.scss";
import { Link } from "react-router-dom";
import arrowBack from "../../assets/Icons/arrow_back-24px.svg";
import axios from "axios";

class NewWarehouse extends Component {
  state = {
    WarehouseName: "",
    StreetAddress: "",
    City: "",
    Country: "",
    ContactName: "",
    Position: "",
    PhoneNumber: "",
    Email: "",
  };

  componentDidMount() {
    // change title of webpage
    document.title = "New Warehouse";
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const newWarehouse = {
      name: this.state.WarehouseName,
      address: this.state.StreetAddress,
      city: this.state.City,
      country: this.state.Country,
      contact: {
        name: this.state.ContactName,
        position: this.state.Position,
        phone: this.state.PhoneNumber,
        email: this.state.Email,
      },
    };
    // calls isFormValid to make sure all inputs are valid before editing
    // if valid updated data is sent to backend
    if (this.isFormValid()) {
      axios
        .post(
          "https://instock-api-rbht.onrender.com/api/v1/warehouses",
          newWarehouse
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // redirect them to home page
    this.props.history.goBack();
  };

  // uses values from isWareHouseValid & isContactValid to see if form as a whole is valid
  isFormValid = () => {
    if (!this.isWareHouseValid() && !this.isContactValid()) {
      return false;
    }

    return true;
  };

  // function to check if contact info is valid
  isContactValid = () => {
    if (
      !this.stateContactName.trim() ||
      !this.state.Position.trim() ||
      !this.state.PhoneNumber.trim() ||
      !this.state.Email.trim()
    ) {
      return false;
    }
    return true;
  };

  // function to check if warehouse info is valid
  isWareHouseValid = () => {
    if (
      !this.state.WarehouseName.trim() ||
      !this.state.StreetAddress.trim() ||
      !this.state.City.trim() ||
      !this.state.Country.trim()
    ) {
      return false;
    }
    return true;
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // returns user to home if cancel button is clicked
  handleCancel = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  render() {
    return (
      <>
        <section className="newWarehouse">
          <div className="newWarehouse-section-wrapper">
            {/* Header */}
            <div className="newWarehouse__title-wrapper">
              <Link
                to={"/warehouse"}
                className="newWarehouse__title--icon-link"
              >
                <img
                  className="newWarehouse__title--icon"
                  alt="go back arrow"
                  src={arrowBack}
                />
              </Link>
              <h1 className="newWarehouse__title">New Warehouse</h1>
            </div>
            <div className="newWarehouse-wrapper">
              {/* Warehouse details section*/}
              <form className="newWarehouse__form" onSubmit={this.handleSubmit}>
                {/* Tablet wrapper wraps both warehouse and contact details div for tablet view */}
                <div className="newWarehouse-tablet-wrapper">
                  <div className="newWarehouse__details">
                    <h2 className="newWarehouse__details--header">
                      Warehouse Details
                    </h2>
                    {/* Warehouse details form*/}
                    {/*Warehouse Name */}
                    <label className="newWarehouse__form--label">
                      Warehouse Name
                    </label>
                    <input
                      className={
                        this.state.WarehouseName.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.WarehouseName}
                      name="WarehouseName"
                      placeholder="Warehouse Name"
                    ></input>
                    {/* Street adress */}
                    <label className="newWarehouse__form--label">
                      Street Address
                    </label>
                    <input
                      className={
                        this.state.StreetAddress.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.StreetAddress}
                      name="StreetAddress"
                      placeholder="Street Address"
                    ></input>
                    {/* City */}
                    <label className="newWarehouse__form--label">City</label>
                    <input
                      className={
                        this.state.City.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.City}
                      name="City"
                      placeholder="City"
                    ></input>
                    {/* Country */}
                    <label className="newWarehouse__form--label">Country</label>
                    <input
                      className={
                        this.state.Country.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.Country}
                      name="Country"
                      placeholder="Country"
                    ></input>
                  </div>
                  {/* Contact details section*/}
                  <div className="newWarehouse__contact">
                    <h2 className="newWarehouse__contact--header">
                      Contact Details
                    </h2>
                    {/* Contact details form*/}
                    {/*Contact Name */}
                    <label className="newWarehouse__form--label">
                      Contact Name
                    </label>
                    <input
                      className={
                        this.state.ContactName.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.ContactName}
                      placeholder="Contact Name"
                      name="ContactName"
                    ></input>
                    {/*Position*/}
                    <label className="newWarehouse__form--label">
                      Position
                    </label>
                    <input
                      className={
                        this.state.Position.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.Position}
                      placeholder="Position"
                      name="Position"
                    ></input>
                    {/*Phone Number */}
                    <label className="newWarehouse__form--label">
                      Phone Number
                    </label>
                    <input
                      className={
                        this.state.PhoneNumber.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.PhoneNumber}
                      name="PhoneNumber"
                      placeholder="Phone Number"
                    ></input>
                    {/*Email */}
                    <label className="newWarehouse__form--label">Email</label>
                    <input
                      className={
                        this.state.Email.length > 0
                          ? "newWarehouse__form--input"
                          : "newWarehouse__form--input-error"
                      }
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.Email}
                      name="Email"
                      placeholder="Email"
                    ></input>
                  </div>
                </div>
                {/* Buttons Container */}
                <div className="newWarehouse__button-container">
                  <div className="newWarehouse__button-wrapper">
                    <button
                      onClick={this.handleCancel}
                      className="newWarehouse__button--cancel"
                    >
                      Cancel
                    </button>
                    <button
                      className="newWarehouse__button--save"
                      type="submit"
                    >
                      + Add New Warehouse
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default NewWarehouse;
